<template>
  <VanPopup
    :show="show"
    @update:show="emit('update:show', $event)"
    position="bottom"
  >
    <div class="flex flex-col">
      <div class="flex items-center justify-between px-4 py-2">
        <h2 class="text-lg font-bold">{{ $t(`mission.equipment.select`) }}</h2>
        <div class="flex gap-2">
          <button
            class="btn btn-xs btn-outline"
            @click="emit('update:show', false)"
          >
            {{ $t(`Buttons.cancel`) }}
          </button>
          <button
            class="btn btn-xs btn-primary"
            @click="emit('confirm', selectEquipments)"
          >
            {{ $t(`Buttons.confirm`) }}
          </button>
        </div>
      </div>
      <div class="p-1 rounded-lg">
        <EquipmentList
          mode="select"
          @select="selectEquipment"
          :select-ids="selectEquipments.map((v) => v.id)"
        />
      </div>
    </div>
  </VanPopup>
</template>

<script setup lang="ts">
import { useMission } from "@/stores/mission";
import { MateEquipment } from "@/types/entity";
import { showFailToast } from "vant";
import { ref, watch } from "vue";
import { useI18n } from "vue-i18n";

const props = defineProps<{
  show: boolean;
  selectIds?: number[];
  maxCount?: number;
}>();
const missionStore = useMission();

const emit = defineEmits<{
  (e: "update:show", show: boolean): void;
  (e: "confirm", selectEquipments: MateEquipment[]): void;
}>();

const { t } = useI18n();
const selectEquipments = ref<MateEquipment[]>([]);

watch(
  () => props.show,
  (newVal) => {
    if (newVal)
      selectEquipments.value =
        props.selectIds?.map((id) => missionStore.mateEquipmentMap[id]) || [];
  }
);

const selectEquipment = (equipment: MateEquipment) => {
  const idx = selectEquipments.value.findIndex((v) => v.id === equipment.id);
  if (idx !== -1) {
    selectEquipments.value.splice(idx, 1);
  } else {
    if (selectEquipments.value.length >= (props.maxCount || 5)) {
      showFailToast(t(`mission.equipment.max`));
      return;
    }

    selectEquipments.value.push(equipment);
  }
};
</script>
